import * as React from 'react'
import {
  iconInfoCircleM,
  iconTickCircleM,
  iconCrossCircleM,
  iconWarningCircleM
} from 'images'

/** @type {React.ForwardRefExoticComponent<React.RefAttributes<HTMLDivElement> & Props>} */
const Hint = React.forwardRef(function UnforwardedHint(
  { margin = true, text, type },
  ref
) {
  let iconSrc = ''

  switch (type) {
    case 'error':
      iconSrc = iconCrossCircleM
      break
    case 'success':
      iconSrc = iconTickCircleM
      break
    case 'warning':
      iconSrc = iconWarningCircleM
      break
    case 'info':
    default:
      iconSrc = iconInfoCircleM
  }

  return (
    <div
      ref={ref}
      className={[
        'hint',
        type ? `hint--${type}` : '',
        margin ? '' : 'no_margin'
      ].join(' ')}
    >
      <span
        className="hint__icon"
        style={
          /** @type {React.CSSProperties} */ ({
            '--icon-url': `url(${iconSrc})`
          })
        }
      ></span>
      <div
        className="hint__text caption"
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </div>
  )
})

export default Hint

/**
 * @typedef {'info' | 'success' | 'warning' | 'error'} Type
 *
 * @typedef {object} Props
 * @property {boolean} [margin]
 * @property {string} text
 * @property {Type} [type]
 */
